import React, { useRef, useEffect, useState } from "react";
import "./Home.css";

import { gsap, Power3 } from "gsap";
import Nav from "../components/Nav";
import MobileNav from "../components/MobileNav";
import { CgMenuRound, CgCloseO } from 'react-icons/cg'

function Home() {
  const [bgColor, setBgColor] = useState()
  const [ openMenu, setOpenMenu ] = useState()
  let para = useRef(null);
  let myName = useRef(null);
  let myStack = useRef(null);
  let myDetail = useRef(null);

  const humIcon = <CgMenuRound className="humIcon" onClick={() => setOpenMenu(!openMenu)}/>
  const closeIcon = <CgCloseO className="humIcon" onClick={() => setOpenMenu(!openMenu)}/>
 

  useEffect(() => {
    gsap.from(
      [para, myName, myStack, myDetail],
      0.8,
      { duration: 2, opacity: 0, y: -30, ease: Power3.easeOut, stagger: 0.6 },
      0.4
    );
  }, []);

  // Change navbar background-color on scrolling 
  //color is set to empty due to color mismatch
  useEffect(() => {
    document.addEventListener("scroll", () => {
      const backgroundcolor = window.scrollY < 70 ? "" : "#08172b";
      setBgColor(backgroundcolor);
    });
  });


  const toggleNavBg = {
    background: bgColor,
  }

  return (
    <div id="home" className="home">
      <div className="header">
        <div className="logo__container">
          <div className="borderSpin"></div>
          <img className="logo" src={require("../image/logo.jpeg")} alt="" />
        </div>
        <nav style={toggleNavBg} className="nav">
          <Nav />
        </nav>
        <nav className="mobile__nav">
          {!openMenu ? humIcon : closeIcon}
          {openMenu && <MobileNav />}
        </nav>
      </div>
      {/*Content left*/}
      <div className="home__content">
        <div className="content__wrapper">
          <p ref={(el) => (para = el)} className="para1">
            Hi, My name is
          </p>
          <h1 ref={(el) => (myName = el)} className="my__name">
            {"<Gamseng Marak />"}
          </h1>
          <h1 ref={(el) => (myStack = el)} className="my__stack">
            I am a FullStack Developer.
          </h1>
          <p  ref={(el) => (myDetail = el)} className="para2">
            I'm a software engineer specialize in <span>Frontend</span> and{" "}
            <span>Backend</span> development. I build web and
            mobile applications for the people who wants to scale their business.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
